<template>
    <div class="empty-state-container">
        <div class="empty-state-media">
            <img :src="image" alt="" v-if="image">
            <i :class="icon" v-else></i>
        </div>

        <p class="empty-state-text" v-html="text"></p>

        <div class="empty-state-action">
            <slot> </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "error-state",

        props: {
            image: {
                required: false,
                type: String
            },
            icon: {
                required: false,
                type: String,
                default: 'fa fa-exclamation-circle'
            },
            text: {
                type: String,
                default: "Oops! We can't load the content..."
            }
        }
    }
</script>

<style lang="scss" scoped>
    .empty-state-container {
        width: 400px;
        max-width: 100%;
        margin: 0 auto;
        padding: 50px 0;

        .empty-state-media {
            text-align: center;
            margin: 50px;
            i {
                font-size: 112px;
                color: #d9493e;
            }
        }

        .empty-state-text {
            text-align: center;
            font-size: 18px;
            color: #4b4b4b;
            margin: 20px 0 40px 0;
        }
    }

</style>